/* eslint-disable react/no-multi-comp */
import { connect } from 'react-redux'
import { confirmActions } from '../actions'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from './IdentifiedDialog'

class Confirm extends Component {
  handleCancel = () => {
    this.onClose()
  }

  handleOk = () => {
    this.props.confirmFunction()
    this.onClose()
  }

  onClose = () => {
    this.props.clearFunction()
  }

  render() {
    const { handleCancel, handleOk } = this
    const { confirmMessage = '', confirmFunction } = this.props

    return (
      <Dialog
        modalId="confirmacao-global"
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="sm"
        open={!!confirmFunction}
      >
        <DialogTitle id="confirmacao-global-title">Confirmação — Confirmar ação</DialogTitle>
        <DialogContent>{confirmMessage}</DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Não
          </Button>
          <Button onClick={handleOk}>Sim</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

Confirm.propTypes = {
  onClose: PropTypes.func,
  value: PropTypes.string
}

const styles = theme => ({
  root: {
    width: '100%',
  },
  dialog: {
    width: '80%',
    maxHeight: 435
  }
})

const mapStateToProps = state => {
  return {
    confirmMessage: state.confirm.confirmMessage,
    confirmFunction: state.confirm.confirmFunction
  }
}

const mapDispatchToProps = dispatch => {
  return {
    clearFunction: () => {
      dispatch(confirmActions.clearFunction())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Confirm))



// WEBPACK FOOTER //
// ./src/components/Confirm.js